// src/hooks/useInsuranceEnrollments.ts

import { useCallback } from "react";

import type {
  ActivityLog,
  Enrollment,
} from "../contexts/InsuranceContextType";

interface UseInsuranceEnrollmentsOptions {
  setEnrollments: React.Dispatch<
    React.SetStateAction<Enrollment[]>
  >;

  logActivity: (
    activity: Omit<
      ActivityLog,
      "id" | "timestamp"
    >
  ) => void;
}

interface UseInsuranceEnrollmentsReturn {
  addEnrollment: (
    enrollmentData: Omit<
      Enrollment,
      "id" | "createdAt" | "updatedAt"
    >
  ) => Promise<void>;

  updateEnrollment: (
    id: string,
    updates: Partial<Enrollment>
  ) => Promise<void>;

  cancelEnrollment: (
    id: string,
    reason?: string
  ) => Promise<void>;
}

const createEnrollmentId = (): string =>
  `ENR-${Date.now()}`;

export function useInsuranceEnrollments({
  setEnrollments,
  logActivity,
}: UseInsuranceEnrollmentsOptions): UseInsuranceEnrollmentsReturn {
  const addEnrollment = useCallback(
    async (
      enrollmentData: Omit<
        Enrollment,
        "id" | "createdAt" | "updatedAt"
      >
    ) => {
          throw new Error(
            "This action is currently unavailable. Your changes have not been saved."
          );
        },
    [logActivity, setEnrollments]
  );

  const updateEnrollment = useCallback(
    async (
      id: string,
      updates: Partial<Enrollment>
    ) => {
          throw new Error(
            "This action is currently unavailable. Your changes have not been saved."
          );
        },
    [logActivity, setEnrollments]
  );

  const cancelEnrollment = useCallback(
    async (
      id: string,
      reason?: string
    ) => {
          throw new Error(
            "This action is currently unavailable. Your changes have not been saved."
          );
        },
    [logActivity, setEnrollments]
  );

  return {
    addEnrollment,
    updateEnrollment,
    cancelEnrollment,
  };
}